/* eslint-disable camelcase */
import React from 'react';
import { withRouter } from 'react-router-dom';
import Img from '../../Img';
import PrismicLink from '../../Links/PrismicLink';

import styles from './featuredPromoCard.scss';

const FeaturedPromoCardV2 = (props) => {
    const { title, description, image, cta_copy, cta_link } = props.content;
    const { 'data-testid': dataTestId } = props;
    const mobileBg = image && image.mobile;

    const bgImg = (imageObj) => {
        if (imageObj && imageObj.oneX && imageObj.twoX && imageObj.threeX) {
            return (
                <Img
                    useRawSrcSet={true}
                    src={imageObj.oneX}
                    srcSet={`${imageObj.twoX} 2x, ${imageObj.threeX} 3x`}
                    style={{ left: '0%' }}
                />
            );
        } if (imageObj && imageObj.default) {
            return (
                <Img
                    src={imageObj.default}
                    style={{ left: '0%' }}
                />
            );
        }
        return null;
    };

    return (
        <div className={`utr-card ${styles.featuredPromoCard}`}>
            <div className={`card-wrapper`}>
                {bgImg(mobileBg)}
                <div className={`card-view`}>
                    <div className={`content`}>
                        <div className={`title show-ellipsis`} data-testid={dataTestId && `${dataTestId}.name`}>
                            {title}
                        </div>
                        <div className={`description`} dangerouslySetInnerHTML={{ __html: description }} data-testid={dataTestId && `${dataTestId}.description`} />
                        {cta_copy && cta_link && (
                            <div className="cta mt-auto">
                                <PrismicLink link={cta_link}>
                                    <div className="link clickable" data-testid={dataTestId && `${dataTestId}.cta-btn`}>{cta_copy}</div>
                                </PrismicLink>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

FeaturedPromoCardV2.defaultProps = {
    'data-testid': null,
};

export default withRouter(FeaturedPromoCardV2);
